<!-- 地图 -->
<style lang="less" scoped>
.bottom {
  width: 83800/1920vw;
  height: 24000/1080vh;
  margin: 5200/1080vh auto;
  overflow: hidden;
  position: relative;
  background: url("../../../../../../assets/img/chaye/bottom.png");
  background-size: 100% 100%;
  ul {
    width: 83800/1920vw;
    height: 24000/1080vh;
    margin-left: 1500/1080vw;
    // border: 1px solid #FFF;

    li {
      width: 25000/1920vw;
      margin-top: 5900/1080vh;
      padding: 1000/1920vw;
      float: left;
      height: 16000/1080vh;
      margin-right: 2000/1920vw;
      position: relative;
      // border: 1px solid red;
      background: url("../../../../../../assets/img/chaye/li.png");
      background-size: 100% 100%;
      p:nth-child(1) {
        width: 2600/1080vh;
        height: 2600/1080vh;
        text-align: center;
        line-height: 2800/1080vh;
        border-radius: 3px;
        color: rgba(213, 255, 255, 1);
        background: #106cff;
      }
      p:nth-child(2) {
        height: 2000/1080vh;
        font-size: 1600/1080vh;
        color: #fff;
        position: absolute;
        right: 950/1080vh;
        top: 1000/1080vh;
      }
      p:nth-child(3) {
        height: 2000/1080vh;
        font-size: 1600/1080vh;
        color: rgba(92, 178, 255, 1);
        position: absolute;
        right: 900/1080vh;
        top: 3800/1080vh;
      }

      p:nth-child(n + 4) {
        height: 3300/1080vh;
        line-height: 3300/1080vh;
        font-size: 1600/1080vh;
        color: rgba(92, 178, 255, 1);
        span:nth-child(1) {
          width: 50%;
          text-align: left;
          display: block;
          float: left;
          line-height: 2200/1080vh;
        }
        span:nth-child(2) {
          width: 50%;
          text-align: right;
          float: left;
          line-height: 2200/1080vh;
        }
      }

      p:nth-child(4) {
        margin-top: 2.7vh;
      }
    }
  }
  .name {
    font-size: 1.8vh;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
    line-height: 4.3vh;
    padding-top: 0.5vh;
    position: absolute;

    &:before {
      display: block;
      content: "";
      width: 1000/1920vw;
      height: 1.8vh;
      background: rgba(254, 230, 20, 1);
      float: left;
      margin-top: 1.2vh;
      margin-left: 3vh;
      margin-right: 1vh;
      background-size: 100% 100%;
    }
  }
}
</style>

<template>
  <div class="bottom">
    <div class="name">浙江龙井区块链溯源节点</div>

    <ul>
      <swiper
        :options="swiperOption"
        class="swiper-wrap"
        ref="mySwiper"
        v-if="list.length != 0"
      >
        <li class="swiper-slide" v-for="(item, index) in list">
          <p>{{ index + 1 }}</p>
          <p>{{ item.node }}</p>
          <p>{{ item.time }}</p>
          <p>
            <span>区块链编号</span><span>{{ item.id }}</span>
          </p>
          <p>
            <span>操作人</span><span>{{ item.name }}</span>
          </p>
          <p v-if="item.note.length">
            <span>{{ item.note }}</span
            ><span>{{ item.note1 }}</span>
          </p>
        </li>
      </swiper>
    </ul>
  </div>
</template>
<script>
import "../../../../../../../static/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  data() {
    return {
      list: [
        {
          node: "育苗",
          name: "邵建国",
          time: "2016-03-16",
          note: "",
          id: "3117"
        },
        {
          node: "施肥",
          name: "邵建国",
          time: "2016-04-06",
          note: "物料",
          note1: "有机肥",
          id: "4102"
        },
        {
          node: "灌溉",
          name: "王雨",
          time: "2016-04-28",
          note: "灌溉方式",
          note1: "地面流灌",
          id: "4218"
        },
        {
          node: "植保",
          name: "赵大海",
          time: "2017-05-16",
          note: "预防",
          note1: "茶尺蠖",
          id: "5315"
        },
        {
          node: "修剪",
          name: "王雨",
          time: "2018-06-23",
          note: "",
          id: "6624"
        },
        {
          node: "采收",
          name: "孙强",
          time: "2019-03-26",
          note: "采收方式",
          note1: "手采法",
          id: "7435"
        },
        {
          node: "摊青",
          name: "周志勇",
          time: "2019-04-02",
          note: "摊青温度",
          note1: "19度",
          id: "7529"
        },
        {
          node: "杀青",
          name: "周志勇",
          time: "2019-04-11",
          note: "",
          id: "7832"
        },
        {
          node: "揉捻",
          name: "孙强",
          time: "2019-04-17",
          note: "揉捻方式",
          note1: "冷揉",
          id: "7961"
        },
        {
          node: "干燥",
          name: "孙强",
          time: "2019-04-20",
          note: "",
          id: "8221"
        },
        {
          node: "包装",
          name: "孙强",
          time: "2019-04-22",
          note: "包装材质",
          note1: "金属罐包装",
          id: "8265"
        }
      ],
      swiperOption: {
        slidesPerView: "auto",
        // 是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        notNextTick: true,
        // 循环
        loop: true,
        // 设定初始化时slide的索引
        initialSlide: 0,
        roundLengths: true,
        height: 170,
        // 自动播放
        autoplay: {
          delay: 5000,
          stopOnLastSlide: false,
          /* 触摸滑动后是否继续轮播 */
          disableOnInteraction: false
        },

        // 滑动速度
        speed: 800,
        // 滑动方向
        direction: "horizontal",
        slidesPerView: "auto",
        spaceBetween: 0,
        // 小手掌抓取滑动
        grabCursor: true
      }
    };
  },
  components: { swiper, swiperSlide },
  mounted() {}
};
</script>



// WEBPACK FOOTER //
// index.vue?43763eab